<template>
  <div id="create-message-wise-page">
    <div class="page-header" :class="isEdit ? '' : 'card'">
      <div>
        <div v-if="!isEdit">
          <div class="page-header-title">
            <div>
              <h5>Ver/Editar Mensagens</h5>
              <span>Veja/Edite suas mensagens.</span>
            </div>
          </div>
        </div>

        <div v-if="!isEdit">
          <msg-list-button-wise
            :user-messages="userMessage"
            @isEditMessage="isEditMessage"
            @selectMessageToEdit="selectMessageToEdit"
          />
        </div>

        <div v-if="isEdit">
          <cloud-tags-wise />
          <edit-message-in-wise
            :placeholder-uuid="placeholderUuid"
            :selected-message-to-edit="selectedMessageToEdit"
            :user-data="userData"
            @updateFormData="updateFormData"
          />
          <message-edit-flow-wise
            :message="formData.message"
            :selected-message-to-edit="selectedMessageToEdit"
            @updateMessage="updateMessage"
            @resetFormData="resetFormData"
            @sendDataMessageWise="sendDataMessageWise"
            @isEditMessage="isEditMessage"
          />
        </div>

        <info-modal
          v-if="showConfirmModal"
          :is-visible-confirm="showConfirmModal"
          :message="modalMessage"
          @close="showConfirmModal = false"
        />

        <Loading
          v-if="showLoadingModalWise"
          :is-loading="isLoadingModalWise"
          :message="'KAKAK'"
          :status="status"
          @close="showLoadingModalWise = false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import cloudTagsWise from '../CreateMessages/components/cloudTagsWise.vue';

import messageEditFlowWise from './components/messageEditFlowWise.vue';
import editMessageInWise from './components/editMessageInWise.vue';
import { mapActions, mapGetters } from 'vuex';
import { v4 as uuidv4 } from 'uuid';
import { updateMessageInWise } from '../../../../../../api/wise';
import msgListButtonWise from './components/msgListButtonWise.vue';
import infoModal from '../../../components/InfoModal.vue';
import Loading from '../../../components/Loading.vue';

export default {
  components: {
    cloudTagsWise,
    editMessageInWise,
    messageEditFlowWise,
    msgListButtonWise,
    infoModal,
    Loading,
  },

  data() {
    return {
      placeholderUuid: uuidv4(),
      formData: {},
      isEdit: false,
      selectedMessage: {},
      showConfirmModal: false,
      showLoadingModalWise: false,
      isLoadingModalWise: false,
      modalMessage: '',
      status: '',
    };
  },

  computed: {
    ...mapGetters({
      userData: 'getUserData',
      userMessage: 'getUserMessage',
    }),
  },

  methods: {
    ...mapActions({
      loadMessageWise: 'loadMessageWise',
    }),
    createFormData() {
      const date = new Date();
      return {
        device_id: this.userData?.device_id || '',
        user_id: this.userData?._id || '',
        date: date.toLocaleDateString('pt-BR'),
        title: '',
        channel: this.placeholderUuid,
        category: '',
        status: '',
        situation: '',
        message: [],
        notification_1: null,
        notification_2: null,
        notification_3: null,
        notification_4: null,
        notifications: null,
        weekend_shipping_lock: false,
        shipping_schedule: '',
      };
    },

    prepareFormData() {
      const newFormData = new FormData();
      newFormData.append('device_id', this.selectedMessageToEdit.device_id);
      newFormData.append('user_id', this.selectedMessageToEdit.user_id);
      newFormData.append('_id', this.selectedMessageToEdit._id);
      newFormData.append('date', this.selectedMessageToEdit.date);
      newFormData.append('title', this.selectedMessageToEdit.title);
      newFormData.append('channel', this.selectedMessageToEdit.channel);
      newFormData.append('category', this.selectedMessageToEdit.category);
      newFormData.append('status', this.selectedMessageToEdit.status);
      newFormData.append('situation', this.selectedMessageToEdit.situation);
      newFormData.append('notification_1', this.formData.notification_1);
      newFormData.append('notification_2', this.formData.notification_2);
      newFormData.append('notification_3', this.formData.notification_3);
      newFormData.append('notification_4', this.formData.notification_4);
      newFormData.append('shipping_schedule', this.formData.shipping_schedule);
      newFormData.append(
        'weekend_shipping_lock',
        this.formData.weekend_shipping_lock
      );
      newFormData.append(
        'message',
        JSON.stringify(this.formData.message.message)
      );
      newFormData.append(
        'notifications',
        JSON.stringify(this.formData.notifications)
      );
      this.formData.message.message.forEach((msg, index) => {
        if (msg.file) {
          newFormData.append(`file${index + 1}`, msg.file);
        }
      });
      return newFormData;
    },

    updateFormData(data) {
      Object.assign(this.formData, data);
    },

    async updateMessage(newMessage) {
      this.formData.message = newMessage;

      await this.sendDataMessageWise();
    },

    resetFormData() {
      this.formData = this.createFormData();
    },

    async sendDataMessageWise() {
      this.showLoadingModalWise = true;
      this.isLoadingModalWise = true;
      const dataToSent = this.prepareFormData();
      await updateMessageInWise({
        payload: dataToSent,
        message_id: this.selectedMessageToEdit._id,
      })
        .then(data => {
          this.modalMessage = 'success';
        })
        .catch(err => {
          this.modalMessage = 'error';
        });
      await this.loadMessageWise();
      this.resetFormData();
      this.selectedMessageToEdit = [];
      this.showLoadingModalWise = false;
      this.isLoadingModalWise = false;
      this.isEdit = false;
    },

    isEditMessage() {
      this.resetFormData();

      this.isEdit = !this.isEdit;
    },
    selectMessageToEdit({ message }) {
      this.selectedMessageToEdit = message || [];
    },
  },

  created() {
    this.formData = this.createFormData();
  },
};
</script>

<style scoped>
#create-message-wise-page {
  background-color: #f2f7fb;
  font-size: 0.9375rem;
  overflow-x: hidden;
  color: #333;
  font-family: open sans, sans-serif;
  background-image: linear-gradient(rgba(255 255 255 / 0%) 240px, #f2f7fb 0%);
}

*:focus {
  outline: none;
}

a {
  font-size: 13px;
  color: #37474f;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-outf;
}
.card {
  border-radius: 5px;
  -webkit-box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  box-shadow: 0 0 5px 0 rgba(43, 43, 43, 0.1),
    0 11px 6px -7px rgba(43, 43, 43, 0.1);
  border: none;
  margin-bottom: 30px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
.card .card-header {
  background-color: transparent;
  border-bottom: none;
  padding: 20px;
  position: relative;
}

.card .card-header.borderless {
  border-bottom: 0 solid transparent;
}

.card .card-header.borderless + .card-block,
.card .card-header.borderless + .card-block-big,
.card .card-header.borderless + .card-block-small {
  padding-top: 0;
}
.page-header {
  margin: 80px;
}
h4 {
  padding: 0;
  margin: 0;
}
.page-header-title {
  display: flex;
  flex-direction: column;
  padding: 40px 20px;
  font-size: 26px;
  font-weight: 400;
  margin-bottom: 30px;
}
.page-header-title span {
  font-size: 13px;
}
</style>
